import React, {Fragment} from 'react';


const FilterListingsCard = (props) => {

  const imgURL = props.imgURL;
  const propertyTitle = props.propertyTitle;
  const propertyShortDesc = props.propertyShortDesc;
  const propertyPrice = props.propertyPrice;
  return (
    // <div className='filter-body-listings'>
    
    // </div>
    <Fragment>
      <div className='listing-card'>
        <div className='listing-img-div'>
          <img className='listing-img' src={imgURL} title='Life Care' 
          alt='lifecarefront.com'/>
        </div>
        <div className='listing-title-description-div'>
          <p className='listing-title-p'>{propertyTitle}</p>
          <p className='listing-price-p'>{propertyPrice}</p>
          <p className='listing-description'>
            {propertyShortDesc}
            <span className='listing-description-span'>
              <a className='listing-description-link' href='#'> See more.</a>
            </span>
          </p>
        </div>
      </div>
    </Fragment>
  )
};

export default FilterListingsCard;